export const SET_APPENDED_MESSAGES_PATH_TOOL_NAME =
  "set_appended_messages_path";
